// Shared between server (layout) and client (LanguageContext) — must NOT be a 'use client' module.
export type Lang = 'sr' | 'en';
export const LANG_COOKIE = 'smt_lang';
